import React, { useState, useEffect } from "react";
import { FaCircle, FaRegCircle } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation().pathname;
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (itemName) => {
    setSelectedItem(itemName);
  };

  const projectItems = [
    "Project",
    "Project Details",
    "Project Plan",
    "Project Gallery",
    "Project Category",
    "Project Status",
    "Project Specification",
    "Project Counter",
    "Project Contact",
    "Project Certificate",
    "Project Video",
  ];

  const masterSettingsItems = [
    "Menu",
    "Slider",
    "Banner",
    "About",
    "About Specification",
    "Plan Tab",
    "Gallery Tab",
    "Blog",
    "Events",
    "Counter",
    "Milestone",
    "Services",
    "Awards",
    "Testimonial",
    "Leadership",
    "Content",
    "Social Media",
  ];

  useEffect(() => {
    const pathToItem = {
      "/dashboard": "Dashboard",
      "/contact-inquiry": "Contact Inquiry",
      "/careers": "Careers",
      "/projects-inquiry": "Projects Inquiry",
      "/site-settings": "Site Settings",
      "/email-configuration": "Email Configuration",
      "/email-templates": "Email Templates",
      "/project": "Project",
      "/project-details": "Project Details",
      "/plan": "Project Plan",
      "/project-gallery": "Project Gallery",
      "/project-category": "Project Category",
      "/project-status": "Project Status",
      "/specification": "Project Specification",
      "/project-counter": "Project Counter",
      "/project-contact": "Project Contact",
      "/project-certificate": "Project Certificate",
      "/project-video": "Project Video",
      "/menu": "Menu",
      "/slider": "Slider",
      "/banner": "Banner",
      "/about": "About",
      "/about-specification": "About Specification",
      "/plan-tab": "Plan Tab",
      "/gallery-tab": "Gallery Tab",
      "/blog": "Blog",
      "/events": "Events",
      "/counter": "Counter",
      "/milestone": "Milestone",
      "/service": "Services",
      "/awards": "Awards",
      "/testimonial": "Testimonial",
      "/leadership": "Leadership",
      "/content": "Content",
      "/social-media": "Social Media",
    };

    if (pathToItem[location]) {
      const newItem = pathToItem[location];
      setSelectedItem(newItem);

      const projectCollapse = document.getElementById("ui-project");
      const masterCollapse = document.getElementById("ui-basic");

      if (projectCollapse && !projectItems.includes(newItem)) {
        projectCollapse.classList.remove("show");
      }
      if (masterCollapse && !masterSettingsItems.includes(newItem)) {
        masterCollapse.classList.remove("show");
      }
    }
  }, [location]);

  return (
    <>
      <nav
        className={`sidebar sidebar-offcanvas ${location.pathname === "/" || location.pathname === "/forgot-password"
          ? "d-none"
          : ""
          }`}
        id="sidebar"
      >
        <ul className="nav">
          <li
            className={`nav-item nav-profile ${selectedItem === "Dashboard" ? "active" : ""
              }`}
          >
            <Link
              className="nav-link"
              to="/dashboard"
              onClick={() => handleItemClick("Dashboard")}
            >
              <span className="menu-title">Dashboard</span>
              <i className="icon-screen-desktop menu-icon" />
            </Link>
          </li>

          <li
            className={`nav-item ${selectedItem === "Contact Inquiry" ? "active" : ""
              }`}
          >
            <Link
              className="nav-link"
              to="/contact-inquiry"
              onClick={() => handleItemClick("Contact Inquiry")}
            >
              <span className="menu-title">Contact Inquiry</span>
              <i className="icon-user menu-icon"></i>
            </Link>
          </li>
          <li
            className={`nav-item ${selectedItem === "Careers" ? "active" : ""
              }`}
          >
            <Link
              className="nav-link"
              to="/careers"
              onClick={() => handleItemClick("Careers")}
            >
              <span className="menu-title">Careers</span>
              <i className="icon-user menu-icon"></i>
            </Link>
          </li>
          <li
            className={`nav-item ${selectedItem === "Projects Inquiry" ? "active" : ""}`}
          >
            <Link
              className="nav-link"
              to="/projects-inquiry"
              onClick={() => handleItemClick("Projects Inquiry")}
            >
              <span className="menu-title">Projects Inquiry</span>
              <i className="icon-user menu-icon"></i>
            </Link>
          </li>
          <li
            className={`nav-item ${selectedItem === "Site Settings" ? "active" : ""
              }`}
          >
            <Link
              className="nav-link"
              to="/site-settings"
              onClick={() => handleItemClick("Site Settings")}
            >
              <span className="menu-title">Site Settings</span>
              <i className="icon-settings menu-icon" />
            </Link>
          </li>
          <li
            className={`nav-item ${selectedItem === "Email Configuration" ? "active" : ""
              }`}
          >
            <Link
              className="nav-link"
              to="/email-configuration"
              onClick={() => handleItemClick("Email Configuration")}
            >
              <span className="menu-title">Email Configuration</span>
              <i className="icon-globe menu-icon" />
            </Link>
          </li>
          <li
            className={`nav-item ${selectedItem === "Email Templates" ? "active" : ""
              }`}
          >
            <Link
              className="nav-link"
              to="/email-templates"
              onClick={() => handleItemClick("Email Templates")}
            >
              <span className="menu-title">Email Templates</span>
              <i className="icon-globe menu-icon" />
            </Link>
          </li>
          <li className={`nav-item ${projectItems.includes(selectedItem) ? 'active' : ''}`}>
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#ui-project"
              aria-expanded="false"
              aria-controls="ui-project"
            >
              <span className="menu-title">Projects</span>
              <i className="icon-layers menu-icon" />
            </a>
            <div className="collapse" id="ui-project">
              <ul className="nav flex-column sub-menu">
                <li
                  className={`nav-item ${selectedItem === "Project" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project"
                    onClick={() => handleItemClick("Project")}
                  >
                    {selectedItem === "Project" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Details" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project-details"
                    onClick={() => handleItemClick("Project Details")}
                  >
                    {selectedItem === "Project Details" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Details
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Plan" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/plan"
                    onClick={() => handleItemClick("Project Plan")}
                  >
                    {selectedItem === "Project Plan" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Plan
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Gallery" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project-gallery"
                    onClick={() => handleItemClick("Project Gallery")}
                  >
                    {selectedItem === "Project Gallery" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Gallery
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Category" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project-category"
                    onClick={() => handleItemClick("Project Category")}
                  >
                    {selectedItem === "Project Category" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Category
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Status" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project-status"
                    onClick={() => handleItemClick("Project Status")}
                  >
                    {selectedItem === "Project Status" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Status
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Specification" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/specification"
                    onClick={() => handleItemClick("Project Specification")}
                  >
                    {selectedItem === "Project Specification" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Specification
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Counter" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project-counter"
                    onClick={() => handleItemClick("Project Counter")}
                  >
                    {selectedItem === "Project Counter" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Counter
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Contact" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project-contact"
                    onClick={() => handleItemClick("Project Contact")}
                  >
                    {selectedItem === "Project Contact" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Contact
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Certificate" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project-certificate"
                    onClick={() => handleItemClick("Project Certificate")}
                  >
                    {selectedItem === "Project Certificate" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Certificate
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Project Video" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/project-video"
                    onClick={() => handleItemClick("Project Video")}
                  >
                    {selectedItem === "Project Video" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Project Video
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className={`nav-item ${masterSettingsItems.includes(selectedItem) ? 'active' : ''}`}>
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#ui-basic"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <span className="menu-title">Master Settings</span>
              <i className="icon-layers menu-icon" />
            </a>
            <div className="collapse" id="ui-basic">
              <ul className="nav flex-column sub-menu">
                <li
                  className={`nav-item ${selectedItem === "Menu" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/menu"
                    onClick={() => handleItemClick("Menu")}
                  >
                    {selectedItem === "Menu" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    Menu
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Slider" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/slider"
                    onClick={() => handleItemClick("Slider")}
                  >
                    {selectedItem === "Slider" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    Slider
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Banner" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/banner"
                    onClick={() => handleItemClick("Banner")}
                  >
                    {selectedItem === "Banner" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    Banner
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "About" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/about"
                    onClick={() => handleItemClick("About")}
                  >
                    {selectedItem === "About" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    About
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "About Specification" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/about-specification"
                    onClick={() => handleItemClick("About Specification")}
                  >
                    {selectedItem === "About Specification" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    About Specification
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Plan Tab" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/plan-tab"
                    onClick={() => handleItemClick("Plan Tab")}
                  >
                    {selectedItem === "Plan Tab" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Plan Tab
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Gallery Tab" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/gallery-tab"
                    onClick={() => handleItemClick("Gallery Tab")}
                  >
                    {selectedItem === "Gallery Tab" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Gallery Tab
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Blog" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/blog"
                    onClick={() => handleItemClick("Blog")}
                  >
                    {selectedItem === "Blog" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    Blog
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Events" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/events"
                    onClick={() => handleItemClick("Events")}
                  >
                    {selectedItem === "Events" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    Events
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Counter" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/counter"
                    onClick={() => handleItemClick("Counter")}
                  >
                    {selectedItem === "Counter" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    Counter
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Milestone" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/milestone"
                    onClick={() => handleItemClick("Milestone")}
                  >
                    {selectedItem === "Milestone" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    Milestone
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Services" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/service"
                    onClick={() => handleItemClick("Services")}
                  >
                    {selectedItem === "Services" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Service
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Awards" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/awards"
                    onClick={() => handleItemClick("Awards")}
                  >
                    {selectedItem === "Awards" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Awards
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Testimonial" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/testimonial"
                    onClick={() => handleItemClick("Testimonial")}
                  >
                    {selectedItem === "Testimonial" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Testimonial
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Leadership" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/leadership"
                    onClick={() => handleItemClick("Leadership")}
                  >
                    {selectedItem === "Leadership" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Leadership
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Content" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/content"
                    onClick={() => handleItemClick("Content")}
                  >
                    {selectedItem === "Content" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}
                    Content
                  </Link>
                </li>
                <li
                  className={`nav-item ${selectedItem === "Social Media" ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link"
                    to="/social-media"
                    onClick={() => handleItemClick("Social Media")}
                  >
                    {selectedItem === "Social Media" ? (
                      <FaCircle className="text-success mx-3" />
                    ) : (
                      <FaRegCircle className="mx-3" />
                    )}{" "}
                    Social Media
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
